/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, {useState, useEffect, useContext, useRef} from "react";
import {useHistory} from 'react-router-dom';
import {Form, Formik, Field} from 'formik';
import * as yup from 'yup';

/* import { GlobalAuthContext, GlobalOperationContext } from 'store/context'; */

import {Row, Col} from "components/Grid";
import {Label, SelectField} from "components/Form";
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, {ButtonContainer, ButtonContent} from 'components/Button';
import {FileModal, EndorsementTagList} from '@fitinsur/components'
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import DialogComponent, {DialogConfirm, DialogRejected, ContentTextArea, TextArea2} from 'components/Dialog';
import FilesAttachment from "components/FilesAttachment";
import RenderButtons from 'components/RenderButtons';
import {GlobalLoaderContext} from 'store/context';
import {GlobalAuthContext} from 'store/context';
import {FitinsurAPI, MessageCenter} from 'utils';

import HasPermission from "components/HasPermission/index";
import {Text, Line} from "./styles";
import {useWordingHtmlModal, useHeaderNbi} from 'services/QuoteService';
import {usePolicyPackListDirectors} from 'services/PolicyService';
import {useOperationInfo} from 'services/OperationService';
import {
  useGetQuestionnaireAnswer,
} from '@fitinsur/services/QuestionnaireAnswerService';

//Mudar Conforme tela
export default function PolicyPackDirectorApproval(props) {
  const [idProduct, setIdProduct] = useState(null);
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [userComments, setUserComments] = useState(null);
  const authContext = useContext(GlobalAuthContext);
  const [canApprove, setCanApprove] = useState(false);
  const [isDenied, setIsDenied] = useState(false);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [statusEndorsement, setStatusEndorsement] = useState({
    title: "Policy Pack",
    route: "",
  });
  const [directorsList, setDirectorsList] = useState(null);
  const [loggedPerson, setLoggedPerson] = useState({});
  const [canSendDocs, setCanSendDocs] = useState(null);
  const [endorsementDocuments, setEndorsementDocuments] = useState([]);
  const [isDirectorLogged, setIsDirectorLogged] = useState(false);
  const [optionApprovalDirector, setOptionApprovalDirector] = useState(false);

  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);

  const [historymsg, setHistorymsg] = useState([]);

  const {
    data: useWordingHtmlModalData,
    loading: useWordingHtmlModalLoading,
    error: useWordingHtmlModalError,
    status: useWordingHtmlModalStatus,
    request: useWordingHtmlModalRequest,
  } = useWordingHtmlModal(props.match.params.idOperation);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: usePolicyPackListDirectorsData,
    loading: usePolicyPackListDirectorsLoading,
    error: usePolicyPackListDirectorsError,
    status: usePolicyPackListDirectorsStatus,
    request: usePolicyPackListDirectorsRequest,
  } = usePolicyPackListDirectors(props.match.params.idOperation);

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  useEffect(() => {
    if (useWordingHtmlModalLoading || useHeaderNbiLoading || usePolicyPackListDirectorsLoading || useOperationInfoLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useWordingHtmlModalLoading, useHeaderNbiLoading, usePolicyPackListDirectorsLoading, useOperationInfoLoading]);

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
              `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }

  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        obligorCoding: data.ret_value.obligorCoding,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        nmObligor: data.ret_value.nmObligor,
        projectName: data.ret_value.projectName,
        isFramework: data.ret_value.isFramework,
        idOperation: props.match.params.idOperation,
      });
      if (data.ret_value.paymentPackMessage) {
        formik.current?.setFieldValue('policyPackDirectorApprovalMessage', data.ret_value.paymentPackMessage);
      }
      setHistorymsg(data.ret_value.historical);
      setEndorsmentType(data.ret_value.endorsmentType)
    })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleFile() {
    useWordingHtmlModalRequest(null, {renderWelcomekit: 1}).then(({data: resp}) => {
      if (resp.ret_code === 200) {
        setFile(resp.ret_value.policePackReturnDocs
          .filter(document => {
            return  ![272, 399, 401, 450, 453, 397, 493, 367].includes(document.idDomain);
          })
          .map(document => ({
            idDocument: document.idDocument,
            idDomainDescription: document.idDomainDescription,
            idReport: document.idReport,
            idOperation: document.idOperation,
            reportToken: document.reportToken,
            url: document.url,
            fileName: document.documentMetadata.fileName
          })))
        setCanApprove(resp.ret_value.canApprove)
        setIsDenied(resp.ret_value.isDenied)
        setCanSendDocs(resp.ret_value.canSendDocs)
        if (resp.ret_value.paymentPackMessage) {
          if (formik.current) {
            formik.current?.setFieldValue('policyPackDirectorApprovalMessage', resp.ret_value.paymentPackMessage);
          }
        }
      } else {
        mc.error(resp.ret_msg_details);
      }
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
      console.error('fitPostReject - Error:', error);
    });
  };

  function handleListDirectors() {
    setLoggedPerson(authContext.login_response.ret_value);
    usePolicyPackListDirectorsRequest().then(({data: resp}) => {
      if (resp.ret_code === 200) {
        const directors = resp.ret_value;
        const isDirectorLogged = directors && directors.find(director => director.idPerson === authContext.login_response?.ret_value?.idPerson);
        const optionApproval = isDirectorLogged?.optionApproval === "Sent";

        setOptionApprovalDirector(optionApproval)
        setIsDirectorLogged(isDirectorLogged)
        setDirectorsList(directors);
      } else {
        mc.error(resp.ret_msg_details);
      }
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleListDirectors.name}\n` + error);
      console.error('fitPostReject - Error:', error);
    });
  }

  const handleEndorsementDocuments = (data) => {
    let questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks,
      ...data.mrc,
    ];

    const endorsementDocumentsQst = questionnaire.find((qst) => qst.idQuestion === 1867)

    if (endorsementDocumentsQst?.answer) {
      const documents = JSON.parse(endorsementDocumentsQst.answer) || []
      setEndorsementDocuments(documents)
    }
  }

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleEndorsementDocuments(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);


  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  function handleCancel() {
    setUserComments("");
    setDialog({
      visible: false,
      title: '',
      icon: 'exclamation',
      args: null
    })
  }

  function handleDialog(type) {
    if (type === "approve") {
      setTypeDialog("approve");
      setDialog({
        visible: true,
        title: "APPROVE POLICY PACK Request",
        icon: "TimesCircle",
        args: null,
      })
    } else if (type === 'rejected') {
      setTypeDialog("rejected");
      setDialog({
        visible: true,
        title: "REJECT POLICY PACK REQUEST",
        icon: "TimesCircle",
        args: null,
      })
    } else {
      setDialog({
        visible: false,
        title: "",
        icon: "",
        args: null,
      })
    }
  };

  function handleApproval() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.paymentPackApprove(props.match.params.idOperation, userComments)
      .then(response => response.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          setCanSendDocs(resp.ret_value.canSendDocs);
          loading.stop();
          history.push('/policies');
        } else {
          loading.stop();
          mc.error(resp.ret_msg_details);
        }
      })
      .catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${handleApproval.name}\n` + error);
        console.error('fitPostAproval - Error:', error);
      })
  };

  function handleReject() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.paymentPackReject(props.match.params.idOperation, userComments)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          mc.success("Approval Police Pack Rejected");
          history.push('/policies');
        } else {
          loading.stop();
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
      console.error('fitPostReject - Error:', error);
    });
  };


  const goToLoginPage = () => {
    history.push('login');
  };

  async function handleOperationInfo() {
    useOperationInfoRequest().then(({data: response}) => {
      setIdProduct(response?.idProduct);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }


  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    //colocar chamadas necessárias no periodo de loading da tela
    let v = handleHistoryMessage()
    if (formik.current) {
      formik.current?.setFieldValue('dealAnalisysInformation', v)
    }
  }, [historymsg])

  useEffect(() => {
    handleListDirectors();
    getStatus(directorsList);
  }, [canSendDocs]);

  useEffect(() => {
    getStatus(directorsList);
  }, [directorsList])

  useEffect(() => {
    handleFile();
    handleSummary();
    handleListDirectors();
    handleOperationInfo();
    useGetQuestionnairesAnswersRequest();
  }, []);

  useEffect(() => {
    if (endorsmentType === 'pre-agreed') {
      setStatusEndorsement({
        title: "ENDORSEMENT - ANNIVERSARY: PREMIUM PRE AGREED / APPROVAL",
        route: ''
      })
    } else if (endorsmentType === 'not-pre-agreed') {
      setStatusEndorsement({
        title: "ENDORSEMENT - ANNIVERSARY: PREMIUM NOT PRE AGREED / APPROVAL",
        route: ''
      })
    } else if (endorsmentType === 'off-risk') {
      return;
    } else if (endorsmentType === 'cancellation') {
      setStatusEndorsement({
        title: "ENDORSEMENT - CANCELLATION / APPROVAL",
        route: ''
      })
    } else if (endorsmentType === 'market-changes') {
      setStatusEndorsement({
        title: "RISK & MARKET CHANGES / APPROVAL",
        route: ''
      })
    }
  }, [endorsmentType])

  function handleSendPolicyPackDirector() {
    history.push(`/broking/policy-pack-send-director/${props.match.params.idOperation}`);
  }

  const columns = [
    {
      title: "Director",
      value: "directorName",
      col: 4,
      style: ''
    },
    {
      title: "Comments",
      value: "comments",
      col: 4,
      style: ''
    },
    {
      title: "Status",
      value: "status",
      col: 4,
      style: ''
    },
  ];

  const options = [
    {
      label: "SENT",
      value: "Sent",
    },
    {
      label: "APPROVED",
      value: "approve"
    },
    {
      label: "DECLINED",
      value: "rejected"
    }
  ];

  function getStatus(directors) {
    if (directors) {
      directors.map((director, index) => {
        formik.current?.setFieldValue(`statusPolicePack${index}`, director.optionApproval);
      })
    }
  }

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}>
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation}/>
      <BrokingSummary data={summary}/>

      <ContentCard
        title={statusEndorsement.title}
        icon info={{
        idOperation: props.match?.params?.idOperation || null,
        idProduct: props.location?.state?.idProduct || null
      }}>

        <DialogComponent icon={dialog.icon} title={dialog.title} show={dialog.visible} setDialog={setDialog}>
          {typeDialog === 'approve' ?
            <ContentTextArea>
              <p>Deal Analysis information</p>
              <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
              <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
              <DialogConfirm onClick={() => handleApproval()}>CONFIRM</DialogConfirm>
            </ContentTextArea>

            : typeDialog === 'rejected' ?
              <ContentTextArea>
                <p>Deal Analysis information</p>
                <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
                <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
              </ContentTextArea>
              : ""
          }
        </DialogComponent>
        <Formik
          innerRef={formik}
          initialValues={{
            policyPackDirectorApprovalMessage: 'Loading...',
            dealAnalisysInformation: '',
            statusPolicePack: ''
          }}
          onSubmit={''}
        >

          {formikProps => (
            <Form>
              {!summary.isFramework && <Row>
                <Col>
                  <Field
                    readOnly
                    label={'Message'}
                    name={'policyPackDirectorApprovalMessage'}
                    value={formikProps.values.policyPackDirectorApprovalMessage}
                    onChange={(e) => formikProps?.setFieldValue('policyPackDirectorApprovalMessage', e)}
                    component={TextField}
                  />
                </Col>
              </Row>}
              <FileModal idOperation={props?.match?.params?.idOperation} documents={file}/>

              <EndorsementTagList
                tags={endorsementDocuments}
                showRemoveIcon={false}
                attachments={[]}
              />

              <div style={{margin: '10px auto', width: '98%'}}>
                <span>
                  <Row>
                    {canApprove && columns && columns.map((column, index) => {
                      return (
                        <Col sm={column.col} key={index} className={'d-none d-md-block pl-0 ' + column.style}>
                          <Text>
                            {column.title}
                          </Text>
                        </Col>
                      )
                    })}
                  </Row>
                </span>
                {canApprove && directorsList && directorsList.map((director, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Row style={{marginTop: '5px'}}>
                        <Col sm={4} md={4} className="pl-0">
                          <Label textColor={Colors.GRAY[0]}>
                            {director.name}
                          </Label>
                        </Col>
                        <Col sm={4} md={4} className="pl-0">
                          <Label textColor={Colors.GRAY[0]}>
                            {director.comments}
                          </Label>
                        </Col>

                        <Col sm={4} md={4} className="pl-0">
                          <Field
                            key={index}
                            name={`statusPolicePack${index}`}
                            component={SelectField}
                            options={options}
                            validation={false}
                            weight="400"
                            value={formikProps.values.statusPolicePack[index]}
                            disabled={director.optionApproval !== 'Sent' || director.idPerson !== loggedPerson?.idPerson}
                            onChange={(e) => {
                              formikProps?.setFieldValue(`statusPolicePack${index}`, e);
                              handleDialog(e)
                            }
                            }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col className="pl-2 pr-2">
                          <Line style={{display: index === directorsList.length - 1 ? 'none' : null}}/>
                        </Col>
                      </Row>
                    </React.Fragment>
                  )
                })}
              </div>
              <Field
                readOnly
                label={'Deal Analysis Information'}
                name={'dealAnalisysInformation'}
                value={formikProps.values.dealAnalisysInformation}
                onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                component={TextField}
              />
              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                {/* <RenderButtons idOperation={props.match?.params?.idOperation}>
                  <ButtonContent>
                    <HasPermission permission={!isDenied && canApprove && isDirectorLogged}>
                      <Button
                        third
                        type="submit"
                        id="btnReject"
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        disabled={isDirectorLogged && optionApprovalDirector ? false : true}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog('rejected')}}
                        
                      >
                        REJECT ENDORSEMENT PACK
                      </Button>
                    </HasPermission>

                      <HasPermission permission={!isDenied && canApprove && isDirectorLogged}>
                        <Button
                          primary
                          type="submit"
                          id="btnApprove"
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          disabled={isDirectorLogged && optionApprovalDirector ? false : true}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog('approve')}}>
                          APPROVE ENDORSEMENT PACK
                        </Button>
                      </HasPermission> 
                  </ButtonContent>
                </RenderButtons> */}
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen/>)}
    </Layout>
  );
}
